<script>
    import Messages from "./helpers/messages/Messages.js";
    import Auth from "./helpers/Auth";

    export let language = 'en-US';
    export let auth_endpoint = '/auth/';

    Messages.registerLanguageVersion(language);

    let email;
    let password;

    let mainError = null;
    let emailError = null;
    let passwordError = null;

    let loading = false;

    const auth = new Auth({
        auth_endpoint
    });

    const signUp = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        emailError = null;
        passwordError = null;

        try {
            const response = await auth.signup(email, password);
            console.log(response);
            if (response.status === 'ok') {
                if (window.localStorage.getItem('selectedTariffFromLanding') !== 'undefined') {
                    window.location.href = '/payment';
                    return false;
                }
                window.location.href = '/';
            }
        } catch (error) {
            if (error.response.data.errors) {
                if (error.response.data.errors.password) {
                    passwordError = error.response.data.errors.password;
                }

                if (error.response.data.errors.email) {
                    emailError = error.response.data.errors.email;
                }
            }
        }
    }
</script>

<header>
    <a href="/" class="logo {language}"></a>
</header>

<div class="clean-signup-form">
    <form class="auth-form" on:submit = {signUp}>
        {#if mainError}
            <div class="error">{mainError}</div>
        {/if}

        <h1 class="text-center">
            {Messages.t('signup_form', 'TITLE')}
        </h1>

        {#if language === 'en-US'}
            <p class="text-center">{Messages.t('signup_form', 'MESSAGE')}</p>
        {/if}
        {#if language === 'ru-RU'}
            <div>
                <p class="popup-content__description">
                    Войдите с помощью соц. сетей
                </p>
                <p class="popup-content__description">
                    <a href = "https://oauth.vk.com/authorize?client_id=51457675&redirect_uri=https%3A%2F%2Fauth.insta-parser.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dvkontakte%26redirectUrl%3Dhttps%253A%252F%252Finsta-parser.ru%252Fauth%252Flogin&response_type=code&scope=email" role="button" title="VK" class="popup-content__auth-btn">
                        <img src="/images/socials/auth_vk.svg"/>
                    </a>

                    <a href = "https://oauth.yandex.ru/authorize?client_id=c85c62ff7a7e42d2a15e782670fc5b2c&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dyandex%26redirectUrl%3Dhttps%3A%2F%2Finsta-parser.ru%2Fauth%2Flogin&response_type=code" role="button" title="Google" class="popup-content__auth-btn">
                        <img src="/images/socials/auth_ya.svg"/>
                    </a>

                    <a href = "https://connect.ok.ru/oauth/authorize?client_id=512001803864&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dodnoklassniki%26redirectUrl%3Dhttps%3A%2F%2Finsta-parser.ru%2Fauth%2Flogin&response_type=code&scope=GET_EMAIL" role="button" title="Odnoklassniki" class="popup-content__auth-btn">
                        <img src="/images/socials/auth_ok.svg"/>
                    </a>
                </p>
                <p class="popup-content__description">
                    или же заполните форму быстрой регистрации
                </p>
            </div>
        {/if}

        <div class="field-node" class:error = {emailError}>
            <input placeholder={Messages.t('form', 'PLACEHOLDER_EMAIL')} type="text" name="email" id="email" autocomplete="off" bind:value={email} />
            {#if emailError}
                <div class="error">{emailError}</div>
            {/if}
        </div>

        <div class="field-node" class:error = {passwordError}>
            <input placeholder={Messages.t('form', 'PLACEHOLDER_PASSWORD')} type="password" name="password" id="password" autocomplete="off" bind:value={password} />
            {#if passwordError}
                <div class="error">{passwordError}</div>
            {/if}
        </div>
        <div class="field-node">
            <button class:loading = {loading}>{Messages.t('signup_form', 'BUTTON')}</button>
        </div>
        <div class="field-node text-center">
            {Messages.t('signup_form', 'LOGIN_PHRASE')} <a href="/auth/login">{Messages.t('signup_form', 'LOGIN_LINK')}</a>
        </div>
    </form>
</div>
{#if language === 'ru-RU'}
    <p class="text-center privacy-text">
        Совершая регистрацию, Вы даете согласие на обработку персональной <br>
        информации на условиях, определенных <a href="https://insta-parser.ru/privacy.pdf">Политикой конфиденциальности</a>.
    </p>
{/if}

<style lang="scss">
  @import "style";

  .logo {
    &.ru-RU {
      background: url(https://auth.zengram.ru/themes/parser/logo.svg) no-repeat center;
    }

    &.en-US {
      background: url(https://auth.avodata.pro/themes/avodata/logo.png) no-repeat center;
    }
  }
</style>